var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.722 6.278C25.0927 6.64867 25.0927 7.24964 24.722 7.62031L11.4897 20.8526C11.0445 21.2978 10.3227 21.2978 9.87753 20.8526L4.278 15.2531C3.90733 14.8824 3.90733 14.2814 4.278 13.9108C4.64867 13.5401 5.24964 13.5401 5.62031 13.9108L10.6836 18.9741L23.3797 6.278C23.7504 5.90733 24.3513 5.90733 24.722 6.278Z",
    fill: "#5B8E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.fda75f3dc76c2248264f8df1860cd251.svg";
export { ForwardRef as ReactComponent };